// Centralized site configuration
export const SITE_BASE_URL = 'https://dizen.pro';
export const BLOG_BASE_PATH = '/blog';
export const CANONICAL_BLOG_BASE = `${SITE_BASE_URL}${BLOG_BASE_PATH}`;
export const PUBLIC_BLOG_BASE = process.env.PUBLIC_URL || '';
export const SITE_ORG_URL = SITE_BASE_URL; // convenience alias for org/brand URLs
